/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import $cookies from 'vue-cookies';
import sidebarItems from "../layouts/components/vx-sidebar/sidebarItems";

const actions = {

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    updateSidebarWidth({ commit }, width) {
        commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateI18nLocale({ commit }, locale) {
        commit('UPDATE_I18N_LOCALE', locale);
    },
    toggleContentOverlay({ commit }) {
        commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({ commit }, val) {
        commit('UPDATE_THEME', val);
    },


    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },

    //  The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list)
    },
    getUser({commit},payload){
        let url = process.env.VUE_APP_API_BASEURL + '/api/me?access_token=' + payload.token;
        fetch(url).then((res) => {
            return res.json()
        }).then((data) => {
            $cookies.set('role',data.responseDetail.role,60*30*30)
            let user = {
                _id:data.responseDetail._id || '',
                role:data.responseDetail.role || '',
                status:data.responseDetail.status || '',
                email:data.responseDetail.email || '',
                phone:data.responseDetail.phone || '',
                username:data.responseDetail.username || '',
                name:data.responseDetail.name || '',
                agentNumber:data.responseDetail.agentNumber || '',
                profilePic:data.responseDetail.profilePic || null,
                customer:data.responseDetail.customer || null,
                updatedAt:data.responseDetail.updatedAt || ''

            }
            $cookies.set('user',JSON.stringify(user),60*30*30)
            commit('setUser', data.responseDetail);
            if(data.responseDetail.role == 'admin' || data.responseDetail.role == 'manager'){
                commit('setSide',sidebarItems[2])
            }else if(data.responseDetail.role == 'agent'){
                commit('setSide',sidebarItems[1])
            }else if(data.responseDetail.role == 'user') {
                commit('setSide', sidebarItems[0])
            }
        })
    },
    getFlag({commit},payload){
        let url = process.env.VUE_APP_API_BASEURL + '/api/me/announcement?access_token=' + payload.token
        fetch(url).then((response) =>{
            return response.json();
        }).then((result)=>{
            commit('setFlag',result.responseDetail.unread)

        })

    }
}

export default actions
